/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './implant-order-item.reducer';

export const ImplantOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const implantOrderItemEntity = useAppSelector(state => state.implantOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="implantOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.implantOrderItem.detail.title">ImplantOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.id}</dd>
          <dt>
            <span id="remarks">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.remarks">Remarks</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.remarks}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.quantity}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.implantOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{implantOrderItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantOrderItem.implant">Implant</Translate>
          </dt>
          <dd>{implantOrderItemEntity.implant ? implantOrderItemEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantOrderItem.order">Order</Translate>
          </dt>
          <dd>{implantOrderItemEntity.order ? implantOrderItemEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/implant-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/implant-order-item/${implantOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImplantOrderItemDetail;
